import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chevron-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M316.16 366.08L512 561.92l195.84-195.84L768 426.666667l-256 256-256-256 60.16-60.586667z\" fill=\"\" p-id=\"20482\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol